import { render, staticRenderFns } from "./BranchSwitcher.vue?vue&type=template&id=2f6c5e32&scoped=true"
import script from "./BranchSwitcher.vue?vue&type=script&lang=js"
export * from "./BranchSwitcher.vue?vue&type=script&lang=js"
import style0 from "./BranchSwitcher.vue?vue&type=style&index=0&id=2f6c5e32&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f6c5e32",
  null
  
)

export default component.exports